import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  Button,
  Icon,
  InputNumber,
  Modal,
  notification,
  DatePicker,
  Divider
} from "antd";

import { isSuperUser } from "../../../../../../../utils/is-superuser";
import "./styles.css";
import api from "../../../../../../../services/api";

export const NotaFiscalParcela = ({
  idParcela,
  initialValue,
  dataNF: propDataNF,
  data: parcelaData
}) => {
  const [isEditing, setEditing] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [numberNF, setNumberNF] = useState(initialValue);
  const [dataNF, setDataNF] = useState(propDataNF);
  const [isConciliado, setConciliado] = useState(
    parcelaData.status_conciliado === "CONCILIADO"
  );

  const ref = useRef();

  const toggleEditing = () => setEditing(!isEditing);

  const handleSave = () => {
    setSaving(true);

    const numeroNF = ref.current.inputNumberRef.state.value;

    api
      .put(`/acordo/parcela/${idParcela}/`, {
        ...parcelaData,
        status_conciliado: "NAO CONCILIADO",
        data_nf: dataNF,
        numero_nf: numeroNF
      })
      .then(() => {
        toggleEditing();
        setNumberNF(numeroNF);
        setConciliado(false);

        notification.success({
          message: "Nota fiscal atualizada com sucesso."
        });
      })
      .catch(() => {
        notification.error({
          message: "Ocorreu um erro ao atualizar a nota fiscal."
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const askConciliar = () =>
    Modal.confirm({
      content: `${isConciliado ? "Desconciliar" : "Conciliar"} nota fiscal?`,
      onCancel: () => null,
      onOk() {
        return api
          .put(`/acordo/parcela/${idParcela}/`, {
            ...parcelaData,
            numero_nf: numberNF,
            status_conciliado: isConciliado ? "NAO CONCILIADO" : "CONCILIADO"
          })
          .then(() => {
            notification.success({
              // eslint-disable-next-line prettier/prettier
              message: `Nota fiscal ${
                isConciliado ? "desconciliada" : "conciliada"
              }.`
            });
            setConciliado(!isConciliado);
          })
          .catch(() => {
            notification.error({
              message: "Ocorreu um erro ao atualizar a nota fiscal."
            });
          })
          .finally(() => {
            setSaving(false);
          });
      }
    });

  const isAdmin = isSuperUser();

  useEffect(() => {
    setNumberNF(parcelaData.numero_nf);
    setConciliado(parcelaData.status_conciliado === "CONCILIADO");
    setCanEdit(parcelaData.status_parcela === "1"); // 1 = recebido
  }, [parcelaData]);

  return (
    <div className="nota_fiscal__container">
      <div className="number_and_date">
        <div
          style={{
            width: "100%",
            display: "flex",
            gap: "10px",
            justifyContent: "space-between"
          }}
        >
          <span className="label">Núm.:</span>
          <span>
            <b>{numberNF || "---"}</b>
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            gap: "10px",
            justifyContent: "space-between"
          }}
        >
          <span className="label">Data:</span>
          <span>{dataNF ? moment(dataNF).format("DD/MM/YYYY") : "---"}</span>
        </div>
      </div>
      {isAdmin && canEdit && (
        <React.Fragment>
          <Divider type="vertical" />
          <Button type="primary" ghost size="small" onClick={toggleEditing}>
            <Icon type="edit" />
          </Button>
        </React.Fragment>
      )}
      {!!numberNF && isAdmin && (
        <React.Fragment>
          <Divider type="vertical" />
          {isConciliado && (
            <Button type="danger" ghost size="small" onClick={askConciliar}>
              DESCONCILIAR
            </Button>
          )}
          {!isConciliado && (
            <Button type="ghost" size="small" onClick={askConciliar}>
              CONCILIAR
            </Button>
          )}
        </React.Fragment>
      )}
      <Modal
        visible={isEditing}
        title="Número Nota Fiscal"
        okText="Salvar"
        cancelText="Cancelar"
        onCancel={toggleEditing}
        confirmLoading={isSaving}
        onOk={handleSave}
        cancelButtonProps={{
          disabled: isSaving
        }}
      >
        <div>
          <label for="value">Insira o número da nota:</label>
          <div style={{ marginTop: "5px" }}>
            {isEditing && (
              <InputNumber
                ref={ref}
                type="number"
                defaultValue={numberNF}
                style={{ width: "100%" }}
                id="value"
                name="value"
                autoFocus
              />
            )}
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          <label for="value">Insira a data da nota fiscal:</label>
          <div style={{ marginTop: "5px" }}>
            {isEditing && (
              <DatePicker
                value={dataNF ? moment(dataNF) : null}
                onChange={(_, date) => setDataNF(date)}
                placeholder="Data da nota fiscal"
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

NotaFiscalParcela.propTypes = {
  initialValue: PropTypes.string,
  dataNF: PropTypes.string,
  idParcela: PropTypes.number,
  data: PropTypes.shape({
    valor_pago: PropTypes.number,
    status_conciliado: PropTypes.string,
    num_parcela: PropTypes.number,
    status_parcela: PropTypes.string,
    id: PropTypes.number,
    data_vencimento: PropTypes.string,
    data_pagamento: PropTypes.string
  })
};



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoParcelas/Parcela/NotaFiscal/index.jsx